import HelmetInfo from "Components/HelmetInfo/HelmetInfo";
import ContactForm from "./Components/ContactForm/ContactForm";
import BreadCrumb from "./Components/BreadCrumb/BreadCrumb";
import { useTranslation } from "react-i18next";

const ContactUs = () => {

  const { t } = useTranslation("contact");
  return (
    <>
      <HelmetInfo titlePage={"تواصل معنا"} />
       <div className="mt-[150px]" />
      <div className="flex flex-col items-center gap-4 max-w-screen-lg mx-auto">
        {/* Breadcrumb */}
        <BreadCrumb />

        {/* Title Section */}
        <div className="text-center flex items-center flex-col gap-6">
          <span className="text-lg font-medium text-[#0d6b70]"></span>
          <h1 className="text-4xl lg:text-[2.75rem] text_bold_Bukra text-[#0d6b70] leading-snug">
            {t('title_contact')}
          </h1>
          <p className="text-lg lg:text-[1rem] font-medium  w-[85%]  text-[#667680] leading-relaxed">
          {t('contact_detials')}
          </p>
        </div>
      </div>
      <div className="lg:mt-[85px]"></div>
      <ContactForm />
    </>
  );
};

export default ContactUs;
